var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWellbeingCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2009 25.125V12.3C38.2009 8.51965 38.2009 6.62947 37.4652 5.18556C36.8181 3.91547 35.7855 2.88285 34.5154 2.23571C33.0715 1.5 31.1813 1.5 27.4009 1.5H13.0009C9.22057 1.5 7.3304 1.5 5.88649 2.23571C4.6164 2.88285 3.58378 3.91547 2.93663 5.18556C2.20093 6.62947 2.20093 8.51965 2.20093 12.3V35.7C2.20093 39.4804 2.20093 41.3705 2.93663 42.8144C3.58378 44.0845 4.6164 45.1171 5.88649 45.7643C7.3304 46.5 9.22057 46.5 13.0009 46.5H20.2009M24.7009 21.75H11.2009M15.7009 30.75H11.2009M29.2009 12.75H11.2009M25.8259 39.75L30.3259 44.25L40.4509 34.125",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeingCheck);
export default __webpack_public_path__ + "static/media/WellbeingCheck.e5ccf711ff106c4851abca9290c8359b.svg";
export { ForwardRef as ReactComponent };